/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import send from "../../../images/send.svg";

const FormFooter = ({ status, message, onValidated }) => {
  let email, name;
  const submit = () =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
    });

  return (
    <div>
      {status === "sending" && <div style={{ color: "white" }}>sending...</div>}
      {status === "error" && (
        <div
          style={{ color: "white" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <div
          style={{ color: "white" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      <div
        sx={{
          display: "flex",
        }}
      >
        <input
          sx={{
            width: "100%",
            padding: "20px 15px",
            boxSizing: "border-box",
            border: "0px",
            borderRadius: "0px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            color: "primary",
            fontSize: "1rem",
            fontFamily: "primary",
            height: "100%",
            "::placeholder": {
              color: "primary",
              fontSize: "1rem",
              fontFamily: "primary",
            },
          }}
          ref={(node) => (email = node)}
          type="email"
          placeholder="Enter your email"
          autocomplete="email"
          title="Enter your email"
        />
        <div
          onClick={submit}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0px 15px",
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
            border: "thin solid white",
            cursor: "pointer",
            ":hover": {
              bg: "primaryDark",
            },
          }}
        >
          <img
            sx={{
              width: "24px",
              maxWidth: "24px",
            }}
            src={send}
            alt="Subscribe to Everplans newsletter"
          />
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
